export const DEPRECATED_ROUTES: string[] = [
]
